var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArbitrum16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16.002,
    viewBox: "0 0 16 16.002",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .002h16v16h-16z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.76 9.937a8 8 0 1 1 -5.826-9.697 8 8 0 0 1 5.826 9.7z",
    fill: "#2d374b",
    transform: "translate(0 -.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56.815 50.236 1-1.692 2.685 4.187v.8l-.009-5.53a.417.417 0 0 0 -.193-.332l-4.84-2.784a.426.426 0 0 0 -.37 0 .4.4 0 0 0 -.043.025l-.017.011-4.7 2.723-.018.008a.425.425 0 0 0 -.069.04.418.418 0 0 0 -.173.313l.007 4.506 2.5-3.881a1.836 1.836 0 0 1 1.64-.671l.748.02-4.41 7.072.52.3 4.463-7.364 1.973-.007-4.451 7.55 1.862 1.07.222.127a.426.426 0 0 0 .3.006l4.908-2.844-.938.544zm.381 5.481-1.873-2.94 1.144-1.941 2.46 3.878z",
    fill: "#2d374b",
    transform: "translate(-47.284 -42.803)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m237.768 260.856 1.873 2.94 1.731-1-2.46-3.878z",
    fill: "#28a0f0",
    transform: "translate(-229.73 -250.882)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m294.821 181.959v-.8l-2.688-4.187-1 1.692 2.6 4.2.938-.544a.416.416 0 0 0 .154-.3z",
    fill: "#28a0f0",
    transform: "translate(-281.603 -171.227)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.219 162.574 1.325.764 4.41-7.072-.748-.02a1.836 1.836 0 0 0 -1.64.671l-2.5 3.881-.842 1.294z",
    fill: "#fff",
    transform: "translate(-18.267 -151.085)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m92.605 156.964-1.973.007-4.463 7.364 1.56.9.424-.719z",
    fill: "#fff",
    transform: "translate(-82.373 -151.783)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m32.315 18.978a1.256 1.256 0 0 0 -.59-1.01l-4.9-2.82a1.276 1.276 0 0 0 -1.125 0c-.041.021-4.769 2.763-4.769 2.763a1.255 1.255 0 0 0 -.71 1.065v5.84l.842-1.294-.007-4.506a.4.4 0 0 1 .006-.049.415.415 0 0 1 .167-.265c.022-.016 4.831-2.8 4.846-2.807a.427.427 0 0 1 .37 0l4.84 2.784a.417.417 0 0 1 .193.332v5.582a.407.407 0 0 1 -.145.3l-.938.544-.484.281-1.731 1-1.755 1.017a.426.426 0 0 1 -.3-.006l-2.077-1.194-.424.719 1.866 1.074.162.092c.07.039.117.065.134.074a1.212 1.212 0 0 0 .5.1 1.248 1.248 0 0 0 .457-.086l5.1-2.952a1.246 1.246 0 0 0 .48-.939z",
    fill: "#96bedc",
    transform: "translate(-18.266 -13.807)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArbitrum16);
export default __webpack_public_path__ + "static/media/ic_arbitrum_16.f4c1a9fe4bec33c78cb944361885f468.svg";
export { ForwardRef as ReactComponent };